import React from 'react';
import { useAtomValue } from 'jotai';
import { dcbAtom, languageAtom, subscriptionAtom } from '@shared/store/slice-atoms';
import {
  isRTL,
  isVariationV3Route,
  isVariationV4Route,
  isVariationV5Route,
  isWhiteDependingOnDOM,
} from '@shared/utils';
import { useDecodeURL } from '@shared/hooks';
import { PAYMENT_METHODS } from '@entities/payment-plan';
import { useLanguage } from '@entities/language/model/hooks/useLanguage';
import { VariationTemplate1InputStyles } from '@features/variation-templates/VariationTemplate1/ui/components/VariationTemplate1InputStyles';
import AppBlack from '@shared/styles/AppBlack';

const ReactPhoneInputCustom = React.lazy(
  () => import('@shared/styles/ReactPhoneInputCustom')
);
const AppBlue = React.lazy(() => import('@shared/styles/AppBlue'));
const AppRtl = React.lazy(() => import('@shared/styles/AppRtl'));
const AppWhite = React.lazy(() => import('@shared/styles/AppWhite'));
const AppReactTelInput = React.lazy(() => import('@shared/styles/AppReactTelInput'));
const AppVoucher = React.lazy(() => import('@shared/styles/AppVoucher'));

const AppParent = ({ children }) => {
  useDecodeURL();

  const subscription = useAtomValue(subscriptionAtom);
  const language = useAtomValue(languageAtom);
  const dcb = useAtomValue(dcbAtom);

  const direction = language.direction;
  const paymentMethod = subscription.paymentMethod;
  const isV3Route = isVariationV3Route(dcb.variationKey);
  const isV4Route = isVariationV4Route(dcb.variationKey);
  const isV5Route = isVariationV5Route(dcb.variationKey);
  const variationTemplate = dcb.templateId;

  const isFirstVariationTemplate = variationTemplate === '1';
  const whiteVariationTemplate = variationTemplate === '1' || variationTemplate === '2';
  const blackVariationTemplate = variationTemplate === '3';

  const ignoreCauseItHasItsOwnSetter = window.location.pathname.includes('/b2b');
  useLanguage(ignoreCauseItHasItsOwnSetter);

  return (
    <>
      {isFirstVariationTemplate ? <VariationTemplate1InputStyles /> : null}
      {blackVariationTemplate ? <AppBlack /> : null}
      {isRTL(direction) ? <AppRtl /> : null}
      {isWhiteDependingOnDOM() || isV4Route || whiteVariationTemplate ? <AppWhite /> : null}
      {isV3Route ? <AppBlue /> : null}
      {paymentMethod === PAYMENT_METHODS.Phone ||
      window.location.pathname.includes('voucher') ||
      window.location.pathname.includes('raffledraw') ? (
        <AppReactTelInput />
      ) : null}
      {window.location.pathname.includes('voucher') ? <AppVoucher /> : null}
      {isV5Route ? <ReactPhoneInputCustom /> : null}
      {children}
    </>
  );
};

export { AppParent };
